import React from "react";
import { Col, Container, Row } from "reactstrap";
import Section from "./Section";
import SummaryWidgets from "./SummaryWidgets";
import EarningsVsSpendChart from "./EarningsVsSpendChart";
import RecentExpenses from "./RecentExpenses";
import TopExpenses from "./TopExpenses";
import TopStock from "./TopStock";
import SuggestionsBlock from "./SuggestionsBlock";

const DashboardEcommerce = () => {
  document.title = "Dashboard | Precious Food";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section />
                <Row className="row-cols-1 row-cols-md-2 row-cols-xl-5">
                  <SummaryWidgets />
                </Row>
                <Row>
                  <Col xl={8}>
                    <EarningsVsSpendChart />
                  </Col>
                  <Col xl={4}>
                    <SuggestionsBlock />
                  </Col>
                </Row>
                <Row>
                  <RecentExpenses />
                  <TopExpenses />
                </Row>
                <Row>
                  <TopStock />
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
